module.exports = __webpack_public_path__ + "img/ill-home-skills-experience.34259076.svg";